
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/pageSettingsPanel/settings/tabs/PageSettingsPermissionsTab/PermissionsTabComponents/membersPermission.scss.css.virtualfile';
        module.exports = {"title":"_title_1p83m_1","memberSections":"_memberSections_1p83m_5"};